<template>
  <div class="container-lg">
    <h1 class="page-header">{{ title }}</h1>
    <ValidationObserver v-slot="{ invalid }">
      <form @submit.prevent="handleSubmit()" name="form">
        <ValidationProvider name="Type" rules="required" v-slot="{ errors }">
          <div class="form-group row">
            <label class="col-sm-3">Type</label>
            <div class="col-sm-4">
              <select class="form-control" v-model="item.entity_type_id">
                <option v-for="i in enity_types" :value="i.id" :key="i.id">{{ i.name }}</option>
              </select>
              <span class="text-danger">{{ errors[0] }}</span>
            </div>
          </div>
        </ValidationProvider>
        <ValidationProvider name="Name" rules="required" v-slot="{ errors }">
          <div class="form-group row">
            <label class="col-sm-3">Name</label>
            <div class="col-sm-9">
              <input class="form-control" type="text" v-model="item.name" />
              <span class="text-danger">{{ errors[0] }}</span>
            </div>
          </div>
        </ValidationProvider>
        <div class="form-group row">
          <label class="col-sm-3">Address</label>
          <div class="col-sm-9">
            <textarea class="form-control" type="text" v-model="item.address" rows=3></textarea>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-3">Postcode</label>
          <div class="col-sm-4">
            <input class="form-control" type="text" v-model="item.postcode" />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-3">Telephone</label>
          <div class="col-sm-6">
            <input class="form-control" type="text" v-model="item.telephone" />
          </div>
        </div>
          <div class="form-group row">
            <label class="col-sm-3">Mobile</label>
            <div class="col-sm-9">
              <input class="form-control" type="text" v-model="item.mobile" />
            </div>
          </div>
        <ValidationProvider name="Email" rules="email" v-slot="{ errors }">
          <div class="form-group row">
            <label class="col-sm-3">Email</label>
            <div class="col-sm-9">
              <input class="form-control" type="text" v-model="item.email" />
              <span class="text-danger">{{ errors[0] }}</span>
            </div>
          </div>
        </ValidationProvider>
        <div class="form-group row">
          <label class="col-sm-3">Notes</label>
          <div class="col-sm-9">
            <textarea class="form-control" type="text" v-model="item.notes" />
          </div>
        </div>

        <div class="form-group row">
          <div class="col-sm-12 text-right">
            <button class="btn btn-light mr-4" type="button" @click="$router.back()">Cancel</button>
            <button class="btn btn-primary" type="submit" :disabled="invalid">Save</button>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { authFetch } from "../lib/auth.js";

export default {
  props: {
    id: String,
  },
  data() {
    return {
      item: {
        // Add fields here so vue watches all fields for changes
        id: null,
        entity_type_id: null,
        name: null,
        adress: null,
        postcode: null,
        telephone: null,
        mobile: null,
        email: null,
        notes: null,
      },
      enity_types: [],
    };
  },
  computed: {
    title() {
      const t = this.enity_types.find(
        (et) => et.id === this.item.entity_type_id
      );
      if (t) {
        return t.name;
      }
      return "Company/contact";
    },
  },
  created() {
    this.load();
  },
  watch: {
    id() {
      this.load();
    },
  },
  methods: {
    handleSubmit() {
      if (this.item.postcode) {
        this.item.postcode = this.item.postcode.toUpperCase();
      }
      if (this.item.id) {
        // Update existing
        authFetch("/db/entity/" + this.item.id, {
          method: "put",
          body: JSON.stringify(this.item),
        }).then((resp) => {
          switch (resp.status) {
            case 200:
              this.$router.back();
              return;
            default:
              alert(resp.statusText);
          }
        });
      } else {
        // Add new
        authFetch("/db/entity", {
          method: "post",
          body: JSON.stringify(this.item),
        }).then((resp) => {
          switch (resp.status) {
            case 200:
              resp.text().then((id) => {
                this.item.id = parseInt(id);
              });
              this.$router.back();
              return;
            default:
              alert(resp.statusText);
          }
        });
      }
    },
    load() {
      authFetch("/db/entity_type").then((resp) =>
        resp.json().then((data) => (this.enity_types = data))
      );
      if (!this.id) {
        Object.assign(this.item, {
          id: null,
          name: "",
        });
        this.item.entity_type_id = this.$route.query.type;
        return;
      } else {
        authFetch("/db/entity/" + this.id)
          .then((resp) => resp.json())
          .then((data) => {
            Object.assign(this.item, data);
          });
      }
    },
  },
};
</script>

<style lang="scss">
</style>